import apiClient from './config';

export const unsubscribe = async (token: string) => {
  return apiClient.get(`/unsubscribe?token=${token}`);
};
